{
  "cancel": {},
  "communicationError": {
    "cancel": {},
    "tryAgain": {}
  },
  "lossPolicy": {},
  "report": {},
  "resource": {},
  "role": {},
  "run": {},
  "success": {
    "close": {}
  },
  "ticket": {},
  "unsuccess": {
    "back": {},
    "cancel": {},
    "proceedAnyway": {}
  }
}
